import {useQuery} from '@tanstack/react-query';
import {AxiosResponse} from 'axios';
import {IApiDataResponse} from '../../dto/API.dto';
import axiosInstance from '../../axiosConfig';

interface IUserPrimaryContactDetails {
  partner_name: string;
  primary_contact_name: string;
  primary_contact_email: string;
  task_name: string;
  requestable_type: string;
  assignment: string;
  created_at: string;
  created_by: number;
  assigned_at: string;
  assigned_by: number;
  assigned_to: number;
  status: string;
}

export const getUsersByTaskApiPath = (taskId: number) => {
  return `v1/task/${taskId}/task-users`;
};

const getUsersByTaskList = (task_id: number) => {
  return axiosInstance
    .get(getUsersByTaskApiPath(task_id))
    .then(
      (
        response: AxiosResponse<IApiDataResponse<{id: number; name: string}[]>>,
      ) => {
        return response.data.data;
      },
    );
};

export const useRqUsersByTask = (task_id: number, enabled: boolean = true) => {
  return useQuery({
    queryKey: [getUsersByTaskApiPath(task_id)],
    queryFn: () => getUsersByTaskList(task_id),
    refetchOnWindowFocus: false,
    retry: false,
    enabled: Boolean(task_id) && enabled,
  });
};

// Task users by task slug.

export const getUsersByTaskSlugApiPath = (slug: string, companyId: number) => {
  return `v1/task/${slug}/company/${companyId}/task-users`;
};

const getUsersByTaskSlugList = (slug: string, companyId: number) => {
  return axiosInstance
    .get(getUsersByTaskSlugApiPath(slug, companyId))
    .then(
      (
        response: AxiosResponse<IApiDataResponse<{id: number; name: string}[]>>,
      ) => {
        return response.data.data;
      },
    );
};

export const useRqUsersByTaskSlug = (
  slug: string,
  companyId: number,
  enabled: boolean = true,
) => {
  return useQuery({
    queryKey: [getUsersByTaskSlugApiPath(slug, companyId)],
    queryFn: () => getUsersByTaskSlugList(slug, companyId),
    refetchOnWindowFocus: false,
    retry: false,
    enabled: Boolean(companyId) && enabled,
  });
};

export const getUsersPrimaryContactByTaskApiPath = (taskId: number) => {
  return `v1/task/${taskId}/get-user-primary-contact-details`;
};

const getUsersPrimaryContactByTaskList = (task_id: number) => {
  return axiosInstance
    .get<IApiDataResponse<IUserPrimaryContactDetails>>(
      getUsersPrimaryContactByTaskApiPath(task_id),
    )
    .then(response => response.data.data);
};

export const useRqUsersPrimaryContactDetailByTask = (
  task_id: number,
  enabled: boolean = true,
) => {
  return useQuery<IUserPrimaryContactDetails>({
    queryKey: [getUsersPrimaryContactByTaskApiPath(task_id)],
    queryFn: () => getUsersPrimaryContactByTaskList(task_id),
    refetchOnWindowFocus: false,
    retry: false,
    enabled: Boolean(task_id) && enabled,
  });
};
